import { Component, Vue } from 'vue-property-decorator';
import { Timer } from 'vue-plugin-timers';
import {
  RegistrationDetailsHeader,
  RegistrationDetailsCustomer,
  RegistrationDetailsCloudAccount,
  RegistrationDetailsInfo,
  RegistrationDetailsNav,
  RegistrationDetailsEditCustomer,
  RegistrationDetailsEditCloudAccount,
  RegistrationDetailsNewCloudAccount,
} from '@/components/registrationDetails';
import IAdminService from '@/services/http/interfaces/IAdminService';
import { AppStoreModule, RegistrationDetailsStoreModule } from '@/store';
import { OnboardingRegistration, OnboardingRegistrationOdinAccount } from '@/common/models';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';
import { RegistrationDetailsForm, RegistrationDetailsOdinRefresh } from '@/common/viewModels';
import RegistrationDetailsStore from '@/store/modules/RegistrationDetailsStoreModule';
import { RegistrationDetailsFormLookups } from '@/common/viewModels/registrationDetails/form/RegistrationDetailsFormLookups';
import AppStore from '@/store/modules/AppStoreModule';

@Component({
  components: {
    RegistrationDetailsHeader,
    RegistrationDetailsCustomer,
    RegistrationDetailsCloudAccount,
    RegistrationDetailsInfo,
    RegistrationDetailsNav,
    RegistrationDetailsEditCustomer,
    RegistrationDetailsEditCloudAccount,
    RegistrationDetailsNewCloudAccount,
  },
})
export default class RegistrationsDetails extends Vue {

  registrationDetails$: RegistrationDetailsStore = RegistrationDetailsStoreModule;
  app$: AppStore = AppStoreModule;

  onboardingRegistrationStatus: typeof OnboardingRegistrationStatus = OnboardingRegistrationStatus;

  private adminService?: IAdminService;

  get registrationId() {
    return this.$route.params.registrationId;
  }

  get onboardingRegistration(): OnboardingRegistration | null {
    return this.registrationDetails$.onboardingRegistration;
  }

  get onboardingRegistrationOdinAccount(): OnboardingRegistrationOdinAccount | undefined {
    return this.registrationDetails$.onboardingRegistrationOdinAccount;
  }

  get onboardingRegistrationOdinAccounts(): OnboardingRegistrationOdinAccount[] {
    return this.registrationDetails$.onboardingRegistrationOdinAccounts;
  }

  get isEdit(): boolean {
    return this.onboardingRegistration ? [OnboardingRegistrationStatus.Submitted, OnboardingRegistrationStatus.Error].indexOf(this.onboardingRegistration.status) >= 0 : false;
  }

  get form(): RegistrationDetailsForm {
    return this.registrationDetails$.form;
  }

  get hasNoPba(): boolean {
    return this.registrationDetails$.onboardingRegistrationOdinAccounts.length === 0;
  }

  get odinDataRefresh(): RegistrationDetailsOdinRefresh {
    return this.registrationDetails$.odinRefresh;
  }

  get showInfo(): boolean {
    return this.onboardingRegistration!.status !== OnboardingRegistrationStatus.Submitted;
  }

  get formLookups(): RegistrationDetailsFormLookups {
    return this.registrationDetails$.form.lookups;
  }

  get isLoading(): boolean {
    return this.app$.isLoading;
  }

  mounted() {
    this.initServices();
    this.registrationDetails$.getRegistrationDetails({ adminService: this.adminService!, registrationId: this.registrationId });

    if (this.hasNoPba) {
      this.registrationDetails$.getLookups();
    }
  }

  initServices(): void {
    this.adminService = this.$factory.createAdminService();
  }

  goBack(): void {
    this.$router.push({
      name: 'Registrations',
    });
  }

  customerFormInputChange(fieldName: string, value: any) {
    this.registrationDetails$.customerFormInputChange({ fieldName, value });
  }

  cloudAccountFormInputChange(fieldName: string, value: any) {
    this.registrationDetails$.cloudAccountFormInputChange({ fieldName, value });
  }

  newCloudAccountFormInputChange(fieldName: string, value: any) {
    this.registrationDetails$.newCloudAccountFormInputChange({ fieldName, value });
  }

  async navAction(actionType: string) {
    const actionMap: any = {
      close: () => () => this.goBack(),
      cancel: () => this.registrationDetails$.requestCancel(this.adminService!),
      create: () => this.registrationDetails$.requestCreate(this.adminService!),
      submit: () => this.registrationDetails$.requestSubmit(this.adminService!),
    };


    const isSuccessful: boolean = await actionMap[actionType]();

    if (isSuccessful && actionType !== 'create') {
      this.goBack();
    }

  }

  getOdinDataClicked(): void {
    this.registrationDetails$.submitOdinDataRefresh(this.adminService!);
  }

  @Timer({ interval: 5000, repeat: true })
  pollOdinAccounts() {
    if (this.odinDataRefresh.isVisible && this.odinDataRefresh.isDisabled) {
      this.registrationDetails$.getOdinAccounts({ adminService: this.adminService!, registrationId: this.onboardingRegistration!.registrationId });
    }
  }

}
